module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"country_code_placeholder":"Country\u0027s name"},"zh":{"country_code_placeholder":"國家的名字"}}')
  delete Component.options._Ctor
}
